<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">兑换核销码</div>
          <div>累计订单：{{ orderData.order_count || 0 }}张，待兑换订单：{{orderData.daiduihuan || 0 }}张</div>
        </div>
        <div class="pictrue">
          <img src="@assets/images/orderTime2.png" />
        </div>
      </div>
    </div>

    <div class="nav acea-row row-around">
      <div
        class="item"
        :class="{ on: type === 0 }"
        @click="$router.replace({ path: '/user/exchange_coupons/0' })"
      >
        <div>可兑换订单</div>
        <div class="num">{{ orderData.daiduihuan || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 1 }"
        @click="$router.replace({ path: '/user/exchange_coupons/1' })"
      >
        <div>已兑换订单</div>
        <div class="num">{{ orderData.yiduihuan || 0 }}</div>
      </div>
    </div>

    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0"
            >拼团</span>
            <span class="sign cart-color acea-row row-center-wrapper" v-if="order.seckill_id > 0">秒杀</span>
            <span class="sign cart-color acea-row row-center-wrapper" v-if="order.bargain_id > 0">砍价</span>
            {{ order._add_time }}
          </div>
        </div>
        <div>
          <div
            class="item-info acea-row row-between row-top"
            v-for="cart in order.cartInfo"
            :key="cart.id"
          >
            <div class="pictrue">
              <img
                :src="cart.productInfo.image"
                v-if="
                  cart.combination_id === 0 &&
                    cart.bargain_id === 0 &&
                    cart.seckill_id === 0
                "
              />
              <img :src="cart.productInfo.image" v-else-if="cart.combination_id > 0" />
              <img :src="cart.productInfo.image" v-else-if="cart.bargain_id > 0" />
              <img :src="cart.productInfo.image" v-else-if="cart.seckill_id > 0" />
            </div>

            <div class="text acea-row row-between">
              <div class="name line2">{{ cart.productInfo.store_name }}</div>
              <div class="money">
                <div>
                  ￥{{
                  cart.productInfo.attrInfo
                  ? cart.productInfo.attrInfo.price
                  : cart.productInfo.price
                  }}
                </div>
                <div>x{{ cart.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          订单号：{{ order.order_id }}
          <br />
          共{{ order.cartInfo.length || 0 }}件商品，总金额
          <span
            class="money font-color-red"
          >￥{{ order.pay_price }}</span>
        </div>

        <div class="bottom acea-row row-right row-middle">
          <template v-if="order.change == 0">
            <router-link :to="'/user/order_exchange/' + order.order_id" class="item">
              <div class="bnt bg-color-red">立即兑换</div>
            </router-link>
          </template>
          <template v-else>
            <div class="bnt cancelBnt">您已兑换</div>
          </template>
        </div>
      </div>
    </div>

    <Loading :loaded="loaded" :loading="loading"></Loading>

    <Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>
  </div>
</template>

<script>
import { getOrderData, getOrderList } from "@api/order";
import { getCouponsCount, getCouponsOrderLest } from "@api/coupons";

import { cancelOrderHandle, takeOrderHandle } from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";

const STATUS = [
  "待付款",
  "待发货",
  "待收货",
  "待评价",
  "已完成",
  "",
  "",
  "",
  "",
  "待付款"
];

const NAME = "ExchangeCoupons";
export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5"
    };
  },
  components: {
    //组件注册
    Loading,
    Payment
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    //检测路由改变
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        this.changeType(type);
      }
    }
  },
  methods: {
    //函数定义
    //获取订单统计信息
    getCouponsCount() {
      getCouponsCount().then(res => {
        this.orderData = res.data;
      });
    },

    /**
     * 获取订单信息
     */
    getOrderData() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getCouponsOrderLest({ page, limit, type }).then(res => {
        console.log("111");
        console.log(res.data);
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },

    reload() {
      this.changeType(this.type);
    },

    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getCouponsCount();
      this.getOrderData();
    },

    //获取状态文字
    getStatus(order) {
      return STATUS[order._status._type];
    },

    cancelOrder(order) {
      cancelOrderHandle(order.order_id)
        .then(() => {
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    }
  },
  mounted() {
    //初始化方法
    this.getCouponsCount(); //获取订单信息
    this.getOrderData(); //获取订单列表
    this.$scroll(this.$refs.container, () => {
      //触底加载
      !this.loading && this.getOrderData();
    });
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
</style>